import React, { useState, useEffect } from 'react';
import * as FieldTypes from "./FieldTypes.js";

const UDIDropdownfield = ({
    UDI,
    setUDI,
    fieldTitle,
	fieldName,
    LOV = [],
    itemHasLink = null,
    mandatory = false,
    forceIsEditing = null
}) => {

    const raw = UDI?.[fieldName];

    const [errorVar, setErrorVar] = useState(false);
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [value, setValue] = useState(raw == null ? '' : String(raw));


    const handleChange = (e) => {
        let newValue = e.target.value;
        setValue(newValue);

        setUDI(prevItem => ({
            ...prevItem,
            [fieldName]: newValue
        }));
    }


    useEffect(() => {

        setErrorVar(mandatory && value === "" ? fieldTitle + " is mandatory" : false);

    }, [value, mandatory]);



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);



	return <>


		<div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    {isEditingField === false ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>

                            <div style={{display: "flex", alignItems: "center"}}>
                                <span
                                    className={`editable-field-span ${errorVar ? "form-field-error" : null }`}
                                    onClick={(e) =>
                                        changeIsEditingField(true)
                                    }
                                >
                                    {value === "" || value === null ? 
                                            <FieldTypes.ItemDetailsField_EmptyValue />
                                        : 
                                            <>
                                                {LOV.find(item => item.key == value)?.value ?? <FieldTypes.ItemDetailsField_EmptyValue />}
                                            </>
                                    }


                                </span>

                                {itemHasLink && value !== null && value !== "" ?
                                    <a href={`${itemHasLink}${value}`} style={{ marginLeft: "15px" }} target="_blank"><i className="fas fa-link"></i></a>
                                : null}
                                
                            </div>

                            {errorVar && (
                                <span className="form-field-error-message">
                                    {errorVar}
                                </span>
                            )}

                        </div>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <span>

                                <select
                                    className={errorVar ? "form-field-error" : ""}
                                    onBlur={() =>
                                    {
                                        changeIsEditingField(false);
                                    }}
                                    onChange={handleChange} value={value}>

                                        {LOV.map((item, index) => (
                                            <option key={index} value={item.key}>{item.value}</option>
			                        ))}

		                        </select>

                            </span>

                            {errorVar && (
                                <span className="form-field-error-message">
                                    {errorVar}
                                </span>
                            )}
                        </div>
                    )}

                </div>
            </div>
        </div>








	</>
}

export default UDIDropdownfield;